import React, {Component} from 'react';
import $ from 'jquery';
import Alert from '../components/Alert';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      message: '',
      phone: '',
      response: '',
      showAlert: false,
      alertType: ''

    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    console.log(this.state.name + ' from this email: '+ this.state.email + 'sent this message: ' + this.state.message);
    const data = {
      name: this.state.name,
      phone: this.state.phone,
      email: this.state.email,
      message: this.state.message

    };

    fetch('/contactus', {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
      'Content-Type': 'application/json'
      },
    }).then((res) => {
      if(res.status === 200) {
        this.setState({alertShow: true, alertType: 'success'});
        $("#form")[0].reset();
        $('#name')[0].value = '';
        $('#email')[0].value = '';
        $('#phone')[0].value = '';
        $('#message')[0].value = '';
        $('#alert').show();
      } else {
        this.setState({alertShow: true, alertType: 'failure'});
        $('#alert').show();
      }
    });
  }
  render() {
    return (
      <div id="contact">
          <h4 className="text-center font-weight-bold section-title">Contact</h4>
          <div className="container">
          {this.state.alertShow ? <Alert alert={this.state.alertType} /> : null}
          <div className="row">
            <div id="contact-text" className="contact-text col-md-6">
              <h2 className="contact-text-renewal contact-text-renewal-top">Was your last renewal everything you had hoped for?</h2>
              <h5 className="contact-text-renewal-items">
                <b>Did you spend hours deciding</b> whether or not to increase your deductible $500, adding an HSA plan, and/or switching carriers yet again for only a 5% savings?
              </h5>
              <h5 className="contact-text-renewal-items">
                Did you feel it in your gut that <b>there had to be other options out there?</b>
              </h5>
              <h5 className="contact-text-renewal-items-please">You are correct, there is! We at Moore Benefit Resources would love to show you to show you Moore.</h5>
              <h5 className="contact-text-renewal-items-please">Please fill out the <a href="#label-name" id="form-link" className="contact-text-renewal-link">contact form</a> and we will do a complete review of your company benefit package(s) or answer any questions you might have.</h5>
              <h3 className="contact-text-renewal contact-text-renewal-bottom">We look forward to hearing from you!</h3>
            </div>
          <div id="form-wrapper" className="col-md-6">
          <form id="form" method="post" name="form" onSubmit={this.handleSubmit}>
          <div id="formTitle">
          <h3 className="text-center font-weight-bold">Contact & Location</h3>
          <br/>
          <div className="map-text">
          <i id="map" className="fas fa-map-marker-alt fa-lg fa-fw"></i>
          <p className="address-text-po">Moore Benefit Resources</p>
          <p className="address-text-po">420 Orchard St, #225</p>
          <p className="address-text-po">Antioch IL. 60002</p>
          <a href="#label-name" id="info-email" className="address-text-email">info@moorebenefitresources.com</a>
          <br/>
          <br/>
          <div id="social">
          <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/Moore-Benefit-Resources-Inc-159663644736052/"><i className="fab fw fa-3x fa-facebook-square" data-toggle="tooltip" data-placement="left" title="Facebook"></i>&nbsp;  </a> 
          <a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/moorebenefitresources/"><i className="fab fw fa-3x fa-instagram" data-toggle="tooltip" data-placement="bottom" title="Instagram"></i>&nbsp;  </a> 
          <a rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/company/moore-benefit-resources/"><i className="fab fw fa-3x fa-linkedin" data-toggle="tooltip" data-placement="right" title="Linkedin"></i>&nbsp;  </a> 
          </div>
          </div>
          </div>
          <br/>
          <div className="form-group">
            <label id="label-name" className="contactForm" htmlFor="name">Full Name:</label>
            <input required name="name" type="text" className="form-control" id="name" aria-describedby="nameHelp" placeholder="Tell us your name" value={this.state.name} onChange={this.handleChange}/>
          </div>
          <div className="form-group">
            <label className="contactForm" htmlFor="phonenum">Phone number:</label>
            <input required minLength="10" title="Best number to reach you at" name="phone" type="text" className="form-control" id="phone" aria-describedby="phoneHelp" placeholder="Best number to reach you at" value={this.state.phone} onChange={this.handleChange}/>
          </div>
          <div className="form-group">
            <label className="contactForm" htmlFor="email">Email:</label>
            <input required title="enter a valid email address" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" type="text" name="email" className="form-control" id="email" aria-describedby="emailHelp" placeholder="eg. jane.doe@gmail.com" value={this.state.email} onChange={this.handleChange}/>
          </div>
          <div className="form-group">
            <label className="contactForm" htmlFor="message">Your question or comment:</label>
            <textarea type="text" minLength="20" name="message" placeholder="Let us know how we can help!" className="form-control" id="message" rows="8" value={this.state.message} onChange={this.handleChange} required="required"></textarea>
          </div>
          <button id="submit" type="submit" value="check" className="btn btn-primary">Submit</button>
        </form>
        </div>
          </div>
          </div>
      </div>
    )
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js